module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-document"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.$t("Mes documents")))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('v-ons-button', {
    attrs: {
      "modifier": "large"
    },
    on: {
      "click": function($event) {
        return _vm.view(6, 'NIE');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-id-card-alt"
  }), _vm._v(_vm._s(_vm.$t("Numéro d'identification d'étranger"))), _c('i', {
    staticClass: "fas fa-id-card-alt absoluteIcon"
  })]), _vm._v(" "), _c('v-ons-button', {
    attrs: {
      "modifier": "large"
    },
    on: {
      "click": function($event) {
        _vm.view(10, _vm.$t('Choix de matériaux'));
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-cart"
  }), _vm._v(_vm._s(_vm.$t("Mes commandes matériaux & Extra"))), _c('i', {
    staticClass: "fas fa-shopping-cart absoluteIcon"
  })]), _vm._v(" "), _c('v-ons-button', {
    attrs: {
      "modifier": "large"
    },
    on: {
      "click": function($event) {
        _vm.view('order', _vm.$t('Mes fournitures'));
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-boxes"
  }), _vm._v(_vm._s(_vm.$t("Mes fournitures"))), _c('i', {
    staticClass: "fas fa-boxes absoluteIcon"
  })]), _vm._v(" "), _c('v-ons-button', {
    attrs: {
      "modifier": "large"
    },
    on: {
      "click": function($event) {
        _vm.view(3, _vm.$t('Contrats d\'achat'));
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-file-contract"
  }), _vm._v(_vm._s(_vm.$t("Contrats d'achat"))), _c('i', {
    staticClass: "fas fa-file-contract absoluteIcon"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f02224","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Documents.vue
// module id = 196
// module chunks = 0